// en.js: PunchLog English locale
// Auto-extracted from: AppShell, EntryList, PlannerPanel, WorkplaceConfig,
//   CalendarGrid, ShiftView, OcrView
export default {
  shell_collapseSidebar: 'Collapse sidebar',
  shell_expandSidebar: 'Expand sidebar',
  shell_navAriaLabel: 'Main navigation',
  shell_offline: 'Offline',
  shell_online: 'Online',
  shell_sidebarAriaLabel: 'Main navigation',
  shell_switchToDark: 'Switch to dark mode',
  shell_switchToLight: 'Switch to light mode',
  shell_syncedAgo: 'Synced {n}',
  shell_syncedHours: '{n}h ago',
  shell_syncedJustNow: 'just now',
  shell_syncedMinutes: '{n}m ago',
  shell_tabPlanner: 'Planner',
  shell_tabReports: 'Reports',
  shell_tabScan: 'Scan',
  shell_tabSettings: 'Settings',
  shell_tabTrack: 'Track',
  // ── AppShell ──────────────────────────────────────────────────────────────
  shell_tagline: 'Verified Labor Data',

  shell_dunningAction: 'Update Payment',
  shell_dunningDismiss: 'Dismiss',
  shell_dunningMessage:
    'Your payment failed. Please update your payment method to keep your subscription active.',

  entry_allWorkplaces: 'All workplaces',
  entry_clearFilters: 'Clear',
  entry_colVariance: 'Variance',
  // ── EntryList ─────────────────────────────────────────────────────────────
  entry_filterAll: 'All',
  entry_filterJobSearch: 'Job Search',
  entry_filterOnCall: 'On-Call',
  entry_filterShift: 'Shift',
  entry_filterTravel: 'Travel',
  entry_groupConcurrent: 'Group concurrent',
  entry_predictiveViolation: 'Predictive scheduling violation (<24h notice)',
  entry_recordMutation: 'Record change',
  entry_showVariance: 'Schedule variance',
  entry_varianceHint: '{n}h vs scheduled',

  dt_deleteRowConfirm: 'This will permanently delete this row. This cannot be undone.',
  dt_deleteRowTitle: 'Delete row',
  dt_emptyTitle: 'No records',
  entry_emptyActionAddWorkplace: 'Add Workplace',
  entry_emptyActionClockIn: 'Clock In Now',
  entry_emptyHintNoWorkplace: 'Create a workplace first to start tracking time.',
  entry_emptySub: 'Clock in on the Track tab to start recording your time.',
  entry_emptySubFiltered: 'Try clearing the filters above.',
  entry_emptyTitle: 'No entries yet',
  entry_emptyTitleFiltered: 'No matching entries',

  entry_colDate: 'Date',
  entry_colHours: 'Hours',
  entry_colIn: 'In',
  entry_colJob: 'Job',
  entry_colOut: 'Out',
  entry_colStatus: 'Status',
  entry_colType: 'Type',
  entry_colWorkplace: 'Workplace',

  entry_concurrentBadge: '{n}× concurrent',
  entry_typeJobSearch: 'job-search',
  entry_typeOnCall: 'on-call',
  entry_typeShift: 'shift',
  entry_typeTravel: 'travel',

  entry_signedLock: 'Sealed: record is immutable',
  entry_statusModified: 'Modified',
  entry_statusOk: 'OK',
  entry_statusSealed: 'Sealed',
  entry_unseal: 'Unseal',
  entry_unsealConfirmBody:
    'Unsealing lets you edit this record. The original sealed version is preserved for audit recovery, and the new editable copy can never be re-sealed.',
  entry_unsealTitle: 'Unseal record',

  entry_concurrentHeading: '{n} concurrent activities, full span {hours}h',
  entry_concurrentHint: 'Switch to Split view to edit or delete individual entries.',
  entry_segColHours: 'Hours',
  entry_segColIn: 'In',
  entry_segColJob: 'Job',
  entry_segColOut: 'Out',
  entry_segColType: 'Type',

  entry_groupEntries: '{n} entry · {hours}h | {n} entries · {hours}h',

  entry_breakUnpaid: '{n}m unpaid',
  entry_dlBreak: 'Break',
  entry_dlCreated: 'Created',
  entry_dlJob: 'Job',
  entry_dlModified: 'Modified',
  entry_dlNotes: 'Notes',

  entry_btnCancel: 'Cancel',
  entry_btnDelete: 'Delete',
  entry_btnEdit: 'Edit',
  entry_btnSave: 'Save',
  entry_editBreak: 'Break (min)',
  entry_editClockIn: 'Clock In',
  entry_editClockOut: 'Clock Out',
  entry_editDate: 'Date',
  entry_editJobPlaceholder: 'e.g. Line Cook',
  entry_editJobTitle: 'Job Title',
  entry_editNotes: 'Notes',
  entry_editType: 'Type',
  entry_editTypeJobSearch: 'Job Search',
  entry_editTypeOnCall: 'On-Call',
  entry_editTypeShift: 'Shift',
  entry_editTypeTravel: 'Travel',

  entry_deleteBtnConfirm: 'Yes, delete',
  entry_deleteConfirm: 'Delete this entry? This cannot be undone.',

  entry_bulkApply: 'Apply',
  entry_bulkClear: 'Clear Selection',
  entry_bulkDelete: 'Delete Selected',
  entry_bulkSelected: '{n} selected',
  entry_bulkToggle: 'Bulk Select',
  entry_bulkType: 'Change type…',
  entry_bulkTypeLabel: 'Bulk entry type',
  entry_bulkWp: 'Change workplace…',
  entry_bulkWpLabel: 'Bulk workplace',
  entry_colCostCode: 'Code',
  entry_deselectAll: 'Deselect all',
  entry_selectAll: 'Select all',
  entry_selectRow: 'Select row',

  planner_chooseFile: 'Choose file…',
  planner_importDesc:
    'Accepts JSON, CSV, or Excel (.xls SpreadsheetML) exported from PunchLog. Each row becomes a time entry.',
  planner_importedSuccess: 'Imported {n} entry. | Imported {n} entries.',
  // ── PlannerPanel ─────────────────────────────────────────────────────────
  planner_importTitle: 'Import',
  planner_skippedBundles: '{n} signed bundle skipped. | {n} signed bundles skipped.',
  planner_templateEntry: 'Download time-entry template',
  planner_templateSchedule: 'Download schedule template',
  planner_xlsxError: '.xlsx is not supported. Export as .xls or CSV from PunchLog and reimport.',

  planner_exportCsvLabel: 'CSV',
  planner_exportCsvSub: 'Comma-separated, opens in Excel & Numbers',
  planner_exportDolLabel: 'Timesheet Report',
  planner_exportDolSub: 'PDF with all hours and entries',
  planner_exportExcelLabel: 'Excel',
  planner_exportExcelSub: 'SpreadsheetML, native .xls format',
  planner_exportInvoiceLabel: 'Invoice PDF',
  planner_exportInvoiceSub: 'PDF billable hours invoice',
  planner_exportJsonLabel: 'JSON',
  planner_exportJsonSub: 'Full audit trail with all fields',
  planner_exportTitle: 'Export',
  planner_hostShareError: 'Failed to host invoice. Please try again.',
  planner_hostShareLabel: 'Host & share',
  planner_hostShareLinkCopied: 'Link copied to clipboard',
  planner_hostShareLinkFailed: 'Could not copy link',
  planner_hostShareSub: 'Hosted link your client can open in a browser',
  planner_invoiceUsageNudge: '{used} of {limit} hosted links used',

  planner_destDrive: 'Save to Drive',
  planner_destDriveHint: 'Connect Google Drive in Settings to enable',
  planner_destLabel: 'Save to',
  planner_destLocal: 'Download',
  planner_destProviderAll: 'Both',
  planner_destProviderLabel: 'Save to which drive',
  planner_driveError: 'Upload failed. Check your connection and try again.',
  planner_driveSaved: 'Saved to Google Drive',
  planner_driveUploading: 'Uploading {name}…',
  planner_exportGroupSchedules: 'Schedules',
  planner_exportGroupTimeEntries: 'Time Entries',
  planner_exportSchedCsvLabel: 'Schedule (CSV)',
  planner_exportSchedCsvSub: 'date, employee, workplace, start/end times',
  planner_exportSchedExcelLabel: 'Schedule (Excel)',
  planner_exportSchedExcelSub: 'SpreadsheetML, import-compatible format',
  planner_exportWorkplaceAll: 'All workplaces',
  planner_exportWorkplaceLabel: 'Workplace',
  planner_includeSeal: 'Include cryptographic seal',
  planner_includeSealHint: 'Adds JWS token or unsigned notice to the PDF',
  planner_moreFormats: 'More formats',

  planner_btnExportData: 'Export',
  planner_cardCompliance: 'Timesheet Report',
  planner_cardDataExport: 'Data Export',
  planner_cardInvoice: 'Invoice',
  planner_formatLabel: 'Format',
  planner_invoiceHideOpts: 'Hide options',
  planner_invoiceShowOpts: 'Show options',
  planner_noSchedules: 'No scheduled shifts to export',
  planner_scopeEntries: 'Time Entries',
  planner_scopeLabel: 'Scope',
  planner_scopeSchedules: 'Schedules',

  planner_btnExport: 'Export…',
  planner_btnImport: 'Import…',
  planner_btnMySchedule: 'My Schedule',

  planner_auditAction: 'Action',
  planner_auditActor: 'Actor',
  planner_auditEmpty: 'No audit entries yet.',
  planner_auditLoading: 'Loading audit log...',
  planner_auditTarget: 'Target',
  planner_auditTime: 'Time',
  planner_btnConfirm: 'Download',
  planner_dayAdd: 'Add to this day',
  planner_dayAssignMember: 'Team member',
  planner_dayAssignMemberPlaceholder: 'Choose a team member',
  planner_dayAssignMemberRequired: 'Choose a team member to assign this shift to.',
  planner_dayBreak: '{n} min break',
  planner_dayBreakMins: 'Break (min)',
  planner_dayCopyShift: 'Copy this shift to another member',
  planner_dayCopyToPlaceholder: 'Copy to...',
  planner_dayDeleteShift: 'Remove shift',
  planner_dayEnd: 'End',
  planner_dayErrorGeneric: 'Something went wrong. Please try again.',
  planner_dayErrorTimes: 'Start and end times are required.',
  planner_dayErrorWorkplace: 'A workplace is required.',
  planner_dayIn: 'Clock in',
  planner_dayLockedByManager: 'This shift is locked by your manager and cannot be edited.',
  planner_dayLockShift: 'Lock this shift',
  planner_dayNoRecords: 'No records for this day.',
  planner_dayOut: 'Clock out',
  planner_daySaveSchedule: 'Add shift',
  planner_daySaveTime: 'Log time',
  planner_dayScheduledShifts: 'Scheduled shifts',
  planner_dayStart: 'Start',
  planner_dayTabAssign: 'Assign',
  planner_dayTabSchedule: 'Schedule',
  planner_dayTabTime: 'Tracked time',
  planner_dayUnlockShift: 'Unlock this shift',
  planner_dayWorkplace: 'Workplace',
  planner_dayWorkplacePlaceholder: 'Select a workplace',
  planner_dayYourShift: 'Your shift',
  planner_manageAudit: 'Audit',
  planner_manageBtn: 'Manage',
  planner_manageSchedules: 'Schedule Templates',
  planner_manageTeam: 'Team',
  planner_manageTitle: 'Manage',
  planner_manageWorkplaces: 'Workplaces',
  planner_mutationBtnCancel: 'Cancel',
  planner_mutationBtnSave: 'Save',
  planner_mutationChangedBy: 'Changed by',
  planner_mutationChangedByPlaceholder: 'e.g. Manager Sarah',
  planner_mutationModalTitle: 'Record Schedule Change',
  planner_mutationMutated: 'Changed to',
  planner_mutationNotes: 'Notes',
  planner_mutationNotesPlaceholder: 'e.g. Texted the night before to come in early',
  planner_mutationNoticeHours: 'Notice given (hours)',
  planner_mutationNoticeHoursPlaceholder: 'e.g. 16',
  planner_mutationNoticeRequired: 'Notice given is required.',
  planner_mutationOriginal: 'Original shift',
  planner_mutationShiftNotFound: 'Shift not found.',
  planner_previewModalTitle: 'Report Preview',
  planner_sectionSummary: 'Summary',
  planner_statDays: 'Days',
  planner_statEstPay: 'Est. Pay',
  planner_statModified: 'Modified',
  planner_statOtDays: 'OT Days',
  planner_statOtDaysTooltip:
    'Days where total hours worked exceeded {threshold}h. Set per workplace in Manage > Workplaces > Hours & OT > Daily OT Threshold (0 disables this for that workplace).',
  planner_statPeriod: 'Period',
  planner_statPredictive: 'Notice Violations',
  planner_statTotalHours: 'Total Hours',
  planner_statUnsigned: 'Unsealed',
  planner_statVarianceDays: 'Schedule Variance',
  planner_statWorkplace: 'Workplace',
  planner_viewManage: 'Manage',
  planner_viewPlan: 'Plan',

  planner_mobileDays: '{n} days',
  planner_mobileOt: '{n} OT',
  planner_mobileTotalHours: '{n}h total',
  planner_mobileUnsigned: '{n} unsealed',

  planner_customFrom: 'Start date',
  planner_customTo: 'End date',
  planner_dateRangeSep: 'to',
  planner_filterAll: 'All',
  planner_filterCustom: 'Custom',
  planner_filterThisMonth: 'This Month',
  planner_filterThisWeek: 'This Week',
  planner_sectionPeriod: 'Period',

  planner_groupDay: 'Day',
  planner_groupHint: 'Applies when switching to list view',
  planner_groupMonth: 'Month',
  planner_groupNone: 'None',
  planner_groupShift: 'Shift',
  planner_groupWeek: 'Week',
  planner_invoiceFrom: 'From (billing profile)',
  planner_invoiceFromDefault: 'Default profile',
  planner_invoiceGrouping: 'Line items by',
  planner_invoiceLimitReached:
    'Free tier invoice limit reached (5/month). Upgrade to Pro for unlimited invoices.',
  planner_invoiceNoProfile:
    'Add a billing profile in Settings to show your name and address on invoices.',
  planner_sectionGroupBy: 'Group By',
  planner_sectionType: 'Entry Type',
  planner_sectionWorkplace: 'Workplace',

  planner_addLogEntry: 'Log Entry',
  planner_addSchedule: 'Schedule',
  planner_sectionAdd: 'Add',

  planner_entryBtnSave: 'Save Entry',
  planner_entryBtnSaved: 'Saved!',
  planner_entryBtnSaving: 'Saving…',
  planner_entryFormBreak: 'Break',
  planner_entryFormDate: 'Date',
  planner_entryFormIn: 'In',
  planner_entryFormOut: 'Out',
  planner_entryFormPlace: 'Place',

  planner_rosterBizOnly: 'Roster import requires Business tier.',
  planner_schedBtnApply: 'Apply to Range',
  planner_schedBtnSave: 'Save Schedule',
  planner_schedBtnSaved: 'Saved!',
  planner_schedBtnSaving: 'Saving…',
  planner_schedFormBreak: 'Break',
  planner_schedFormDays: 'Days',
  planner_schedFormEnd: 'End',
  planner_schedFormName: 'Name',
  planner_schedFormNamePlaceholder: 'e.g. Mon–Fri 9–5',
  planner_schedFormStart: 'Start',

  planner_dowF: 'F',
  planner_dowM: 'M',
  planner_dowSa: 'Sa',
  planner_dowSu: 'Su',
  planner_dowTh: 'Th',
  planner_dowTu: 'Tu',
  planner_dowW: 'W',

  planner_unsignedSeal: '{n} unsealed',
  planner_viewCalendar: 'Calendar',
  planner_viewList: 'List',
  planner_viewTimesheet: 'Timesheet',
  planner_viewToggleLabel: 'View',

  planner_chartHoursByDay: 'Hours by Day',
  planner_chartScheduleVariance: 'Schedule Variance',
  planner_sectionCharts: 'Charts',

  planner_calMode3Day: '3 Day',
  planner_calModeMonth: 'Month',
  planner_calModeWeek: 'Week',
  planner_calModeWorkWeek: 'Work Week',
  planner_calNavToday: 'Today',
  planner_teamViewerLabel: 'View schedule for',
  planner_teamViewerMySchedule: 'My Schedule',
  planner_timesheetAutosave: 'Auto-save entries',
  planner_timesheetSaveAll: 'Save All',
  planner_timesheetTotal: 'Total',
  planner_timesheetWeekTotal: 'Week',
  // ── Timesheet grid ────────────────────────────────────────────────────────
  ts_addCode: 'Add code',
  ts_codePlaceholder: 'CODE',
  ts_labelPlaceholder: 'Label',
  ts_noCodesSub: 'Add a code below or configure codes in workplace settings.',
  ts_noCodesTitle: 'No cost codes configured',
  ts_total: 'Total',
  ts_week: 'Week',
  ts_wpGroup: '{name}',

  calendar_dowFri: 'Fri',
  calendar_dowMon: 'Mon',
  calendar_dowSat: 'Sat',
  calendar_dowSun: 'Sun',
  calendar_dowThu: 'Thu',
  calendar_dowTue: 'Tue',
  calendar_dowWed: 'Wed',
  calendar_entryCount: '{n} entries',
  calendar_hoursLogged: '{n}h',
  calendar_hoursOf: 'of {n}h',
  calendar_hoursPlanned: '{n}h planned',
  calendar_legendIssue: 'Modified/Unsigned',
  calendar_legendOt: 'OT >8h',
  calendar_legendScheduled: 'Scheduled',
  calendar_legendWorked: 'Worked',
  calendar_nextMonth: 'Next month',
  // ── CalendarGrid ─────────────────────────────────────────────────────────
  calendar_prevMonth: 'Previous month',

  config_btnAddWorkplace: 'Add Workplace',
  config_noWorkplaces: 'No workplaces yet. Add one below.',
  // ── WorkplaceConfig ───────────────────────────────────────────────────────
  config_sectionWorkplaces: 'Workplaces',
  config_unnamed: 'Unnamed',

  config_btnAddTemplate: 'Add Template',
  config_noSchedules: 'No templates yet',
  config_sectionSchedules: 'Schedule Templates',

  config_bpAddressHeader: 'Address',
  config_bpCurrency: 'Currency',
  config_bpCurrencyHint: 'Currency used for invoices with this profile',
  config_bpDefault: 'Default profile',
  config_bpDefaultHint: 'Use this profile when none is selected',
  config_bpEmail: 'Email',
  config_bpEmailPlaceholder: 'billing email address',
  config_bpIdentityHeader: 'Identity',
  config_bpName: 'Name',
  config_bpNameHint: 'Appears as the From field on invoices',
  config_bpNamePlaceholder: 'e.g. Acme LLC or Jane Smith',
  config_bpPreferencesHeader: 'Preferences',
  config_btnAddBillingProfile: 'Add profile',
  config_defaultWorkplaceName: 'My Workplace',
  config_deleteBpConfirm: 'Delete this billing profile?',
  config_editBillingProfile: 'Edit Billing Profile',
  config_newBillingProfile: 'New Billing Profile',
  config_noBillingProfiles: 'No billing profiles yet',
  config_sectionBillingProfiles: 'Billing Profiles',
  config_unitPerHour: '/hr',

  config_dataPrivacy: 'Data & Privacy',
  config_dataPrivacySub: 'Export, clear records, storage',
  config_dataSyncNav: 'Data & Sync',
  config_dataSyncNavSub: 'Storage, backup, and cloud synchronization',
  config_integrations: 'Integrations',
  config_integrationsSub: 'Webhooks, outbound events',
  config_planFeatures: 'Plan & Features',
  config_sectionAppSettings: 'App Settings',
  config_syncCloud: 'Sync & Cloud',
  config_syncCloudSub: 'Cloud backup and synchronization',
  config_teams: 'Teams',
  config_teamsSub: 'Multi-member workplaces',
  sync_bpDefault: 'default',
  sync_btnDisconnect: 'Disconnect',
  sync_btnReconnect: 'Reconnect',
  sync_btnRetry: 'Retry',
  sync_btnSyncNow: 'Sync Now',
  sync_chooseHint: 'Choose a cloud provider to sync your data across devices.',
  sync_connectAnother: 'Connect another cloud provider to sync to both at once.',
  sync_connectError:
    "Could not connect. If a sign-in popup didn't appear, check your browser isn't blocking popups for this site.",
  sync_googleDrive: 'Google Drive',
  sync_interactionInProgress:
    "A previous sign-in attempt didn't finish cleanly. Tap Retry to try again.",
  sync_lastSync: 'Last sync: {time}',
  sync_oneDrive: 'OneDrive',
  sync_statusConnected: 'Connected',
  sync_statusConnecting: 'Connecting…',
  sync_statusError: 'Error',
  sync_statusExpired: 'Session expired',
  sync_statusSyncing: 'Syncing…',

  config_editWorkplace: 'Edit Workplace',
  config_newWorkplace: 'New Workplace',

  config_address: 'Address',
  config_address1: 'Street Address',
  config_address1Placeholder: '123 Main St',
  config_address2: 'Suite / Apt',
  config_address2Placeholder: 'Suite 100',
  config_addressHeader: 'Address',
  config_addressPlaceholder: 'Street, City, State, ZIP',
  config_city: 'City',
  config_defaultJobTitle: 'Default Job Title',
  config_defaultJobTitleHint: 'Auto-fills job title on new entries for this workplace',
  config_defaultJobTitlePlaceholder: 'e.g. Line Cook, Software Engineer',
  config_employerLegalName: 'Legal Entity Name',
  config_employerLegalNameHint: 'Appears on exported reports and invoices',
  config_employerLegalNamePlaceholder: 'For official records',
  config_identityHeader: 'Identity',
  config_phone: 'Phone',
  config_phonePlaceholder: '+1 (555) 000-0000',
  config_stateField: 'State',
  config_workplaceName: 'Name',
  config_workplaceNameHint: 'Use a unique name per employer or contract engagement',
  config_workplaceNamePlaceholder: 'e.g. Downtown Bistro',
  config_workplaceNamePlaceholderContract: 'e.g. Acme Corp – Phase 1',
  config_zip: 'ZIP / Postal Code',

  config_isContract: 'This is a contract / freelance engagement',
  config_payCommission: 'Commission',
  config_payHeader: 'Pay',
  config_payHourly: 'Hourly',
  config_paySalary: 'Salary',
  config_payStructure: 'Pay Structure',

  config_hourlyRate: 'Hourly Rate',
  config_hourlyRateHint: 'State min: ${min}/hr',

  config_payPeriod: 'Pay Period',
  config_payPeriodAnnual: 'Annual',
  config_payPeriodBiweekly: 'Bi-weekly',
  config_payPeriodMonthly: 'Monthly',
  config_payPeriodSemimonthly: 'Semi-monthly (24×/yr)',
  config_payPeriodWeekly: 'Weekly',
  config_salaryAmount: 'Salary Amount',
  config_salaryAmountContract: 'Fixed Fee',
  config_salaryAmountContractHint: 'Fixed periodic fee billed regardless of hours logged',

  config_baseRate: 'Base Hourly Rate (optional)',
  config_baseRateContract: 'Base Hourly Fee (optional)',
  config_baseRateHint: '0 = commission-only',
  config_baseRateHintContract: 'Leave blank or enter 0 for commission-only',
  config_commissionPct: 'Commission %',

  config_contractAmount: 'Amount',
  config_contractBilling: 'Client Billing Type',
  config_contractBillingFixed: 'Fixed Price',
  config_contractBillingHourly: 'Hourly',
  config_contractBillingRetainer: 'Retainer',
  config_contractDesc: 'Scope / Deliverable',
  config_contractDescPlaceholder: 'e.g. Phase 1: API integration',
  config_contractPeriod: 'Billing Period',
  config_contractPeriodQuarterly: 'Quarterly',
  config_contractRetainerPlusHourlyHint: 'Retainer base + tracked hours billed on top',

  config_dailyOtHint: '0 = no daily OT',
  config_dailyOtThreshold: 'Daily OT Threshold',
  config_defaultHoursDay: 'Default Hours/Day',
  config_defaultUnpaidBreak: 'Default Unpaid Break',
  config_defaultUnpaidBreakHint: 'Pre-filled on new entries for this workplace',
  config_hoursOtHeader: 'Hours & OT',
  config_weeklyOtThreshold: 'Weekly OT Threshold',

  config_complianceHeader: 'Compliance',
  config_flsaClass: 'FLSA Classification',
  config_flsaContractor: 'Independent Contractor (1099)',
  config_flsaExempt: 'Exempt (salaried, no OT)',
  config_flsaNonExempt: 'Non-exempt (eligible for OT)',
  config_flsaTrainee: 'Trainee / Apprentice',

  config_roundDown15: 'Round down 15 min',
  config_roundingHint: 'Applied to clock-in/out times',
  config_roundNearest15: 'Nearest 15 min',
  config_roundNone: 'None (exact)',
  config_roundUp15: 'Round up 15 min',
  config_stateOtRules: 'State (OT Rules)',
  config_timeRounding: 'Time Rounding',

  config_costCodesHeader: 'Cost Codes',
  config_costCodesHint: 'Defaults shown; per-workplace editor coming soon',
  config_costCodesLabel: 'Active codes for this workplace',

  common_deleteRecord: 'Delete Record',
  common_deleteRecordConfirm: 'Delete this record? This cannot be undone.',
  common_deleteSelected: 'Delete Selected',
  common_deleteSelectedConfirm:
    'Delete {count} selected entry? This cannot be undone. | Delete {count} selected entries? This cannot be undone.',
  config_deleteBp: 'Delete Billing Profile',
  config_deleteSchedule: 'Delete Schedule Template',
  config_deleteWorkplace: 'Delete Workplace',
  config_mergeWorkplaceConfirm: 'Merge {source} into {target}? This cannot be undone.',
  config_mergeWorkplaceCta: 'Merge into another workplace…',
  config_mergeWorkplaceHint:
    'Moves every entry, schedule template, and scheduled shift from {name} onto the workplace you choose below, then deletes {name}. This cannot be undone.',
  config_mergeWorkplaceLabel: 'Merge into',
  config_mergeWorkplaceSelectPrompt: 'Choose a workplace…',
  config_mergeWorkplaceTitle: 'Merge Workplace',

  config_btnCancel: 'Cancel',
  config_btnDelete: 'Delete',
  config_btnSave: 'Save',
  config_btnSaveChanges: 'Save Changes',
  config_btnSaving: 'Saving…',
  config_savedMsg: 'Saved',

  config_btnSaveTemplate: 'Save Template',
  config_daysOfWeek: 'Days of Week',
  config_editTemplate: 'Edit Template',
  config_endTime: 'End Time',
  config_linkedWorkplace: 'Linked Workplace',
  config_linkedWorkplaceAny: 'Any',
  config_newScheduleTemplate: 'New Schedule Template',
  config_scheduleHeader: 'Schedule',
  config_startTime: 'Start Time',
  config_templateName: 'Template Name',
  config_templateNamePlaceholder: 'e.g. Mon–Fri 9–5',
  config_unpaidBreak: 'Unpaid Break',

  config_dayFri: 'Fri',
  config_dayMon: 'Mon',
  config_daySat: 'Sat',
  config_daySun: 'Sun',
  config_dayThu: 'Thu',
  config_dayTue: 'Tue',
  config_dayWed: 'Wed',
  config_noDaysScheduled: 'No days',

  config_btnClearRecords: 'Clear Time Records',
  config_btnExportAll: 'Export All Data (JSON)',
  config_clearDesc:
    'Permanently delete all local time entries. Workplace settings and schedule templates are not affected. This cannot be undone.',
  config_dangerZone: 'Danger Zone',
  config_dataHeader: 'Data & Privacy',
  config_exportDesc:
    'Download a complete copy of all local data as JSON: workplaces, schedules, and every time entry including the full audit trail.',
  config_exportSectionHeader: 'Export',

  config_clearTimeConfirm:
    'All time entries will be permanently deleted. Workplace and billing settings are not affected.',
  config_clearTimeDesc:
    'Removes all shift entries. Workplaces, schedules, and billing profiles are kept.',
  config_clearTimeLabel: 'Clear time records',

  config_btnClearWorkplaces: 'Remove Workplaces',
  config_clearWorkplacesConfirm:
    'All workplaces, schedule templates, and shift schedules will be permanently deleted. Time entries are not affected.',
  config_clearWorkplacesDesc:
    'Removes all workplaces, schedule templates, and shift schedules. Time entries are kept.',
  config_clearWorkplacesLabel: 'Remove workplaces & schedules',

  config_btnClearBilling: 'Remove Billing Profiles',
  config_clearBillingConfirm: 'All billing profiles will be permanently deleted.',
  config_clearBillingDesc: 'Removes all billing profiles. Time entries and workplaces are kept.',
  config_clearBillingLabel: 'Remove billing profiles',

  config_btnResetAll: 'Reset All Local Data',
  config_resetAllConfirm:
    'Every piece of local data will be permanently erased, including signed audit bundles. This cannot be undone.',
  config_resetAllDesc:
    'Wipes all local data: time entries, workplaces, schedules, billing profiles, and signed bundles. Starts fresh.',
  config_resetAllLabel: 'Reset everything',

  config_btnDeleteAccount: 'Delete Account',
  config_deleteAccountConfirm:
    'This will cancel your Stripe subscription (if any), delete all server data (invoices, team, tenant), and wipe every local record. This is permanent and cannot be undone.',
  config_deleteAccountDesc:
    'Cancel any active subscription, delete invoices and team data from the server, and wipe all local data. This cannot be undone.',
  config_deleteAccountLabel: 'Delete Account & Server Data',
  config_deleteAccountSuccess: 'Account deleted successfully.',

  config_sheetBadUrl: 'Could not find a Sheet ID in that URL.',
  config_sheetBtnAdd: 'Add Sheet',
  config_sheetBtnImport: 'Import Entries',
  config_sheetBtnPull: 'Pull now',
  config_sheetBtnRemove: 'Remove',
  config_sheetConflict: 'When an imported entry overlaps an existing one',
  config_sheetConflictKeep: 'Keep both',
  config_sheetConflictOver: 'Overwrite existing',
  config_sheetConflictSkip: 'Skip (keep existing)',
  config_sheetConnectHint: 'Connect Google Drive in Settings to enable Sheet import.',
  config_sheetDefaultWp: 'Assign to workplace (optional)',
  config_sheetDefaultWpNone: 'No workplace',
  config_sheetDone: 'Done: {imported} imported, {skipped} skipped.',
  config_sheetErrors: '{count} row(s) had errors.',
  config_sheetImportDesc:
    'Paste a link to a Google Sheet that contains time entry data. The first row must be a header row.',
  config_sheetImportHeader: 'Import from Google Sheets',
  config_sheetImporting: 'Importing…',
  config_sheetLastPulled: 'Last pulled {time}',
  config_sheetNeverPulled: 'Never pulled',
  config_sheetsSectionHeader: 'Google Sheets',
  config_sheetSyncDesc: 'Add Google Sheets to pull automatically on each sync.',
  config_sheetSyncEmpty: 'No sheets added yet.',
  config_sheetSyncHeader: 'Recurring Sheet Pull',
  config_sheetUrlLabel: 'Sheet URL',
  config_sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/…',

  config_aboutAuditTrail: 'Audit trail',
  config_aboutAuditTrailValue: 'Immutable, local only',
  config_aboutHeader: 'About',
  config_aboutServerSync: 'Server sync',
  config_aboutServerSyncValue: 'None (Free tier)',
  config_aboutStorage: 'Storage',
  config_aboutStorageValue: 'On-device (IndexedDB)',
  config_aboutVersion: 'Version',
  config_autoSignHint: 'Sign each entry cryptographically at clock-in/out',
  config_autoSignLabel: 'Auto-sign entries',
  config_btnConfirmDelete: 'Delete',
  config_dangerExportHint: 'Optionally export a backup first. You can re-import it later.',

  config_planChangePlan: 'Change Plan',
  config_planChecking: 'Checking…',
  config_planCompare: 'Compare all plans',
  config_planCurrentBadge: 'Current',
  config_planFree: 'Free',
  config_planHeader: 'Plan & Features',
  config_planHideComparison: 'Hide comparison',
  config_planLastChecked: 'Last checked {n}',
  config_planManage: 'Manage subscription',
  config_planPerMonth: '/mo',
  config_planRefreshBtn: 'Check for updates',
  config_planSeatsSuffix: ' seats',
  config_planSoon: 'Soon',
  config_planStatus_active: 'Active',
  config_planStatus_canceled: 'Canceled',
  config_planStatus_free: 'Free',
  config_planStatus_past_due: 'Payment failed',
  config_planStatusCancels: 'Cancels',
  config_planStatusInvoiceLinks: 'hosted links this month',
  config_planStatusLabel: 'status',
  config_planStatusSeats: 'seats',
  config_planStatusTier: 'plan',
  config_planUpgrade: 'Upgrade',
  config_planUpgradeSuccess: 'Payment successful. Your plan has been updated.',

  config_btnRemoveWebhook: 'Remove',
  config_btnSaveWebhook: 'Save',
  config_btnTestPayload: 'Test Payload',
  config_emittedEventsHeader: 'Emitted Events',
  config_integrationsHeader: 'Integrations',
  config_webhookDesc:
    'PunchLog sends a signed POST to your URL on each event. Verify requests with the X-PunchLog-Signature HMAC-SHA256 header.',
  config_webhookEventDesc: 'Description',
  config_webhookEventName: 'Event',
  config_webhookHeader: 'Webhook Endpoint',
  config_webhookSaved: 'Saved.',
  config_webhookSecretHint: 'Used to compute X-PunchLog-Signature. Keep this private.',
  config_webhookSecretLabel: 'Signing Secret',
  config_webhookSecretPlaceholder: 'Random string, ≥ 32 chars',
  config_webhookUrlHint: 'Must be HTTPS in production',
  config_webhookUrlLabel: 'Endpoint URL',
  config_webhookUrlPlaceholder: 'https://example.com/webhook',
  config_webhookWarning:
    'Webhooks require a Pro subscription. Configure now; events queue until you upgrade.',

  // Event group labels, keyed config_evtGroup_<group> to match registry group names
  config_evtGroup_entries: 'Time Entries',
  config_evtGroup_invoices: 'Invoices & Exports',
  config_evtGroup_ocr: 'OCR',
  config_evtGroup_schedules: 'Schedules',
  config_evtGroup_sync: 'Sync',
  config_evtGroup_workplaces: 'Workplaces',

  config_teamsAddTeamModalTitle: 'Add a team',
  config_teamsBtnRemove: 'Remove',
  config_teamsCsvHint:
    'One person per line: name, email, role (role optional, defaults to employee).',
  config_teamsCsvImportBtn: 'Import',
  config_teamsCsvLabel: 'Paste rows (name, email, role)',
  config_teamsCsvPlaceholder:
    "Jane Doe, jane{'@'}example.com, employee\nJohn Smith, john{'@'}example.com, manager",
  config_teamsCsvResult: '{invited} invited, {skipped} skipped',
  config_teamsCsvRowFailed: 'Row {row}: could not invite {email}',
  config_teamsCsvRowMissing: 'Row {row}: missing name or email',
  config_teamsDemote: 'Make employee',
  config_teamsEmailPlaceholder: 'Email address',
  config_teamsEmployeeIdPlaceholder: 'Employee ID (optional)',
  config_teamsEmptyDesc: 'Invite a team member to get started.',
  config_teamsEmptyTitle: 'No team members yet',
  config_teamsHeader: 'Teams',
  config_teamsInviteBtn: 'Invite',
  config_teamsInviteCta: 'Invite',
  config_teamsInviteModalTitle: 'Invite team members',
  config_teamsInviteModeCsv: 'CSV import',
  config_teamsInviteModeSingle: 'Single invite',
  config_teamsModalCancel: 'Cancel',
  config_teamsNamePlaceholder: 'Name',
  config_teamsNewTeamBtn: 'Add team',
  config_teamsNewTeamPlaceholder: 'New team name',
  config_teamsPromote: 'Make manager',
  config_teamsRemoveConfirm:
    'This will remove the member and free up their seat. This cannot be undone.',
  config_teamsRemoveTitle: 'Remove team member',
  config_teamsRoleEmployee: 'Employee',
  config_teamsRoleManager: 'Manager',
  config_teamsSelectTeam: 'Select a team',
  config_teamsSelectTeamFirst: 'Select a team to view its members.',
  config_teamsUpsellDesc: 'Invite members, assign schedules, and manage roles across your team.',
  config_teamsUpsellTitle: 'Team management requires the Business plan',
  planner_auditUpsellDesc:
    'See who did what across your team — invites, role changes, and schedule edits.',
  planner_auditUpsellTitle: 'Team audit log requires the Business plan',

  config_teamsAssignBreak: 'Break (min)',
  config_teamsAssignBtn: 'Assign',
  config_teamsAssignDate: 'Shift date',
  config_teamsAssignEmptyDesc: 'Choose someone from the list above to assign a schedule.',
  config_teamsAssignEmptyTitle: 'Select a team member',
  config_teamsAssignEnd: 'End time',
  config_teamsAssignHeader: 'Assign a schedule for {name}',
  config_teamsAssignSaving: 'Signing...',
  config_teamsAssignSelectWorkplace: 'Select a workplace',
  config_teamsAssignStart: 'Start time',
  config_teamsAssignWorkplace: 'Workplace',

  config_teamsBatchAssignBtn: 'Assign week',
  config_teamsBatchAssignHeader: 'Assign a template for the week',
  config_teamsBatchAssignNoneAssigned: 'No shifts were assigned.',
  config_teamsBatchAssignSelectTemplate: 'Select a template',
  config_teamsBatchAssignSummary: '{count} shift(s) assigned',
  config_teamsBatchAssignTemplate: 'Schedule template',
  config_teamsBatchAssignWeek: 'Week of',

  config_clearRecordsConfirm: 'Delete all local time records? This cannot be undone.',
  config_deleteScheduleConfirm: 'Delete {name}?',
  config_deleteWorkplaceConfirm: 'Delete {name}? This cannot be undone.',

  shift_addDefault: 'Add a Default',
  shift_advancedSetup: 'Advanced setup →',
  shift_createOne: 'Create One',
  shift_firstRunDesc:
    'Track your time, protect your wages, and export tamper-proof timesheets, right on your device.',
  shift_firstRunStep1: 'Add a workplace (your employer or client)',
  shift_firstRunStep2: 'Clock in when your shift starts',
  shift_firstRunStep3: 'Export a timesheet whenever you need it',
  // ── ShiftView ─────────────────────────────────────────────────────────────
  shift_firstRunTitle: 'Welcome to PunchLog',
  shift_noWorkplaceBanner: 'No workplace configured.',

  shift_btnCancelModal: 'Cancel',
  shift_btnSaveModal: 'Save',
  shift_newWorkplaceTitle: 'New Workplace',
  shift_wpDefaultHours: 'Default Hours/Day',
  shift_wpNameLabel: 'Name',
  shift_wpNamePlaceholder: 'e.g. Acme Diner',
  shift_wpRateLabel: 'Hourly Rate ($/hr)',

  shift_exportDolSub: 'Signed PDF with your hours and entries',
  shift_exportDolTitle: 'Timesheet Report',
  shift_exportInvoiceSub: 'Client invoice with hours × rate',
  shift_exportInvoiceTitle: 'Invoice PDF',
  shift_exportTitle: 'Export',

  shift_modeLive: 'Live Clock',
  shift_modeManual: 'Manual Entry',

  shift_btnAddWorkplace: 'Add workplace',
  shift_fieldEntryType: 'Entry Type',
  shift_fieldWorkplace: 'Workplace',
  shift_selectWorkplace: 'Select a workplace',
  shift_typeJobSearch: 'Job Search',
  shift_typeOnCall: 'On-Call',
  shift_typeShift: 'Shift',
  shift_typeTravel: 'Travel',
  shift_typeWork: 'Work Session',

  shift_fieldJobTitle: 'Job Title',
  shift_fieldRateOfPay: 'Rate of Pay',
  shift_fieldSchedule: 'Schedule Template',
  shift_jobTitlePlaceholder: 'e.g. Line Cook',
  shift_scheduleNone: 'None',

  shift_clockInRounded: '→ rounded {time}',
  shift_fieldClockIn: 'Clock In',
  shift_fieldClockOut: 'Clock Out',
  shift_fieldDate: 'Date',

  shift_break15: '15m',
  shift_break30: '30m',
  shift_break45: '45m',
  shift_break60: '1h',
  shift_breakCustom: 'Custom',
  shift_breakHint: 'Deducted from compensable hours',
  shift_breakNone: 'None',
  shift_breakPlaceholder: 'min',
  shift_fieldUnpaidBreak: 'Unpaid Break',

  shift_fieldNotes: 'Notes',
  shift_notesPlaceholder: 'Optional…',

  shift_btnClockIn: 'Clock In',
  shift_btnClockOut: 'Clock Out',
  shift_idleHint: 'Select workplace & type in the form, then clock in.',

  shift_btnReset: 'Reset',
  shift_btnSaveEntry: 'Save Entry',
  shift_btnSaving: 'Saving…',
  shift_entrySaved: 'Entry saved',
  shift_manualEnterTimes: 'Enter times in the form',
  shift_manualEstPay: 'Est. {pay}',
  shift_manualPreviewTitle: 'Manual Entry Preview',
  shift_previewCompensable: 'Compensable',
  shift_previewEstPay: 'Est. Pay',
  shift_previewGross: 'Gross Time',
  shift_previewOvertime: 'Overtime',

  shift_sectionEntryDetails: 'Entry Details',

  shift_compensableToday: 'Compensable Today',
  shift_sectionTodayActivity: "Today's Activity",
  shift_spread: 'Spread',
  shift_travel: 'Travel',

  shift_breakdown: 'Time Breakdown',
  shift_daysWorked: 'Days Worked',
  shift_otHours: 'OT Hours',
  shift_sectionSignExport: 'Export',
  shift_sectionThisWeek: 'This Week',
  shift_totalHours: 'Total Hours',

  shift_ledgerTotal: 'Total: {hours}h compensable',
  shift_sectionTodayEntries: "Today's Entries",

  shift_btnExport: 'Export',
  shift_noManualEntries: 'No manual entries',
  shift_noTodayActivity: 'No activity today',
  shift_sealAuditTrail: 'Tamper-evident audit trail',
  shift_sealNone: 'No entries to sign',
  shift_sealPartial: 'Partially signed',
  shift_sealReady: '{n} entry unsigned | {n} entries unsigned',
  shift_sealSigned: 'Signed',
  shift_sectionSealExport: 'Seal & Export',

  shift_otWarning: 'OT: {hours}h at 1.5× applies',

  ocr_btnClear: 'Clear',
  ocr_btnImportToTrack: 'Import to Track',
  ocr_btnScanDocument: 'Scan Document',
  ocr_btnUploadDocument: 'Upload Document',
  // ── OcrView ───────────────────────────────────────────────────────────────
  ocr_parsedResult: 'Parsed Result',
  ocr_scanning: 'Scanning…',
  ocr_tapToScan: 'Tap to scan',

  ocr_sectionDocType: 'Document Type',
  ocr_typePayStub: 'Pay Stub',
  ocr_typePunchCard: 'Punch Card',
  ocr_typeSchedule: 'Schedule',
  ocr_typeTimesheet: 'Timesheet',

  ocr_extractDailyHours: 'Daily hours',
  ocr_extractDate: 'Date',
  ocr_extractDateRange: 'Date range',
  ocr_extractDaysOfWeek: 'Days of week',
  ocr_extractEmployeeName: 'Employee name',
  ocr_extractEmpName: 'Employer name',
  ocr_extractGrossPay: 'Gross pay',
  ocr_extractHourlyRate: 'Hourly rate',
  ocr_extractHoursWorked: 'Hours worked',
  ocr_extractLocation: 'Location',
  ocr_extractNetPay: 'Net pay',
  ocr_extractOvertime: 'Overtime',
  ocr_extractPayPeriod: 'Pay period',
  ocr_extractPosition: 'Position / role',
  ocr_extractPunchIn: 'Punch-in times',
  ocr_extractPunchOut: 'Punch-out times',
  ocr_extractShiftTimes: 'Shift times',
  ocr_extractTotalHours: 'Total hours',
  ocr_sectionExtracts: 'Extracts',

  ocr_privacyBanner: 'OCR runs on-device. No document data leaves your phone.',

  ocr_noScansYet: 'No scans yet',
  ocr_sectionRecentScans: 'Recent Scans',

  ocr_clockIn: 'In',
  ocr_clockOut: 'Out',
  ocr_comparisonCheckHint:
    'This pay stub shows {gross} gross / {net} net. Compare it against your tracked hours in Reports.',
  ocr_comparisonTimesheetHint:
    'This timesheet shows {hours} total hours. Compare it against your tracked hours in Reports.',
  ocr_selectPair: 'Select clock in / clock out pair',

  config_btnAddReportConfig: 'New Config',
  config_defaultBadge: 'Default',
  config_locationPlural: 'locations',
  config_locationSingular: 'location',
  config_noReportConfigs:
    'No report configs yet. Add one to customise invoice and timesheet branding.',
  config_profilePlural: 'profiles',
  config_profileSingular: 'profile',
  config_reportConfigPlural: 'configs',
  config_reportConfigSingular: 'config',
  config_sectionReportConfigs: 'Report Configs',
  config_templatePlural: 'templates',
  config_templateSingular: 'template',
  ocr_btnCancelShifts: 'Discard',
  ocr_btnConfirmShifts: 'Add to calendar',
  ocr_scheduleReviewHint:
    'Review the shifts found on this schedule before adding them to your calendar.',
  ocr_scheduleReviewSkipped: 'Could not read a day or time range for this entry — skipped.',
  ocr_scheduleReviewTitle: 'Confirm scanned shifts',
  rcs_hidePreview: 'Hide',
  rcs_previewHeader: 'Preview',
  rcs_showPreview: 'Show preview',
  reports_clientsBadge: 'Pro',
  reports_clientsHeader: 'Clients this month',
  reports_clientsHours: 'Hours',
  reports_clientsInvoiceCount: '{n} invoice(s) this month',
  reports_clientsInvoiced: 'Invoiced',
  reports_downloadTitle: 'Download',
  reports_emptySub: 'Generate an invoice or timesheet from the export screen to see it here.',
  reports_emptyTitle: 'No reports yet',
  reports_filterCreated: 'Date Created',
  reports_filterIncluded: 'Date Included',
  reports_filterType: 'Report Type',
  reports_filterTypeAll: 'All',
  reports_filterTypeInvoice: 'Invoice',
  reports_filterTypeTimesheet: 'Timesheet',
  reports_filterWorkplace: 'Workplace',
  reports_filterWorkplaceAll: 'All Workplaces',
  reports_header: 'Reports & Exports',
  reports_invoicesEmpty: 'No invoices yet',
  reports_invoicesEmptySub: 'Send an invoice from the export screen to see it here.',
  reports_invoicesLoading: 'Loading invoices…',
  reports_invoicesLocked: 'Client invoices are a Basic tier feature',
  reports_invoicesLockedSub: 'Upgrade to Freelancer Basic to see hosted invoice status.',
  reports_invoicesStatus_sent: 'Sent',
  reports_invoicesStatus_viewed: 'Viewed',
  reports_navExportsSub: 'Timesheet and invoice PDFs',
  reports_navIntegrationsSub: 'Webhook automation',
  reports_navInvoicesSub: 'Hosted invoice links and status',
  reports_scanComparisonDismiss: 'Dismiss',
  reports_scanComparisonTitle: 'Scanned document comparison',
  reports_tabExports: 'PDF Exports',
  reports_tabIntegrations: 'Integrations',
  reports_tabInvoices: 'Client Invoices',
  rp_billTo: 'Bill To',
  rp_colAmount: 'Amount',
  rp_colClockIn: 'Clock In',
  rp_colClockOut: 'Clock Out',
  rp_colDate: 'Date',
  rp_colDescription: 'Description',
  rp_colHours: 'Hours',
  rp_colRate: 'Rate',
  rp_defaultLogoText: 'PunchLog',
  rp_employee: 'Employee',
  rp_from: 'From',
  rp_labelInvoice: 'Invoice',
  rp_labelTimesheet: 'Timesheet',
  rp_page1: 'Page 1 of 1',
  rp_previewTitle: 'Report preview',
  rp_sampleClientAddress: '123 Main St, Anytown CA 90210',
  rp_sampleClientName: 'Sample Client Co.',
  rp_sampleConsulting: 'Software consulting',
  rp_sampleDocs: 'Documentation',
  rp_sampleFromEmail: "your{'@'}email.com",
  rp_sampleFromName: 'Your Name / Company',
  rp_sampleReview: 'Code review',
  rp_total: 'Total',

  rc_accentColor: 'Accent Color',
  rc_billingProfile: 'Billing Profile',
  rc_billingProfileEmpty: 'No billing profiles yet. Add one in Settings.',
  rc_billingProfileNone: 'None (use sample data)',
  rc_headerEdit: 'Edit Report Config',
  rc_headerNew: 'New Report Config',
  rc_logoText: 'Logo Text',
  rc_logoTextHintFromBilling: 'Falls back to billing profile: {name}',
  rc_logoTextHintOverride: 'Overrides the billing profile name.',
  rc_logoTextPlaceholder: 'Company name shown as logo',
  rc_name: 'Config Name',
  rc_namePlaceholder: 'e.g. Default Invoice',
  rc_orientation: 'Orientation',
  rc_reportTitle: 'Report Title Override',
  rc_reportTitlePlaceholder: 'Leave blank to use default title',
  rc_reportType: 'Report Type',
  rc_sectionBranding: 'Branding',
  rc_sectionIdentity: 'Identity',
  rc_sectionLayout: 'Layout',
  rc_setDefault: 'Set as Default',
  rc_showBillingName: 'Show billing profile name alongside logo',

  config_bpLogoAlt: 'Company logo preview',
  config_bpLogoChange: 'Change logo',
  config_bpLogoHeader: 'Logo',
  config_bpLogoHint: 'PNG, JPG or SVG. Displayed on invoices and exports.',
  config_bpLogoLabel: 'Company Logo',
  config_bpLogoRemove: 'Remove',
  config_bpLogoUpload: 'Upload logo',
  ocr_tabRecent: 'Recent',
  ocr_tabScan: 'Scan',

  about_app_description:
    'Offline-first time tracking and invoicing with a cryptographic audit trail.',
  config_menuAbout: 'About',
  config_menuAboutSub: 'Version and app info',
  legal_footer_privacy: 'Privacy Policy',
  legal_footer_terms: 'Terms of Service',
  legal_menuSub_privacy: 'What data we collect and how it is used',
  legal_menuSub_terms: 'Subscription terms and acceptable use',
  legal_privacy_changes_p1:
    'We may update this policy from time to time. Material changes will be announced in-app. The "Last updated" date at the top of this page reflects the most recent revision.',
  legal_privacy_changes_title: 'Changes to This Policy',
  legal_privacy_cloudSync_p1:
    'If you connect Google Drive or OneDrive, PunchLog creates a backup of your local data in your own cloud storage account. Data is encrypted in transit (HTTPS) and stored in your personal drive. PunchLog never has access to read your synced data. You may disconnect cloud sync at any time.',
  legal_privacy_cloudSync_title: 'Cloud Sync (Optional)',
  legal_privacy_contact_title: 'Contact',
  legal_privacy_dataCollected_intro:
    'PunchLog collects the following categories of data. All data is stored locally on your device:',
  legal_privacy_dataCollected_invoices:
    'Invoice data is generated locally on your device. On paid tiers, hosted invoice URLs are stored in Cloudflare R2 to support link sharing.',
  legal_privacy_dataCollected_invoices_label: 'Invoices',
  legal_privacy_dataCollected_location:
    'Captured when you clock in and out, if you grant location permission. Stored locally on your device only and never uploaded to our servers.',
  legal_privacy_dataCollected_location_label: 'GPS Location',
  legal_privacy_dataCollected_scan:
    'OCR processing runs entirely on your device. Document images are never uploaded to any server.',
  legal_privacy_dataCollected_scan_label: 'Scanned Documents',
  legal_privacy_dataCollected_schedule:
    'Workplace names, addresses, schedule templates, and shift records. All data stays on your device.',
  legal_privacy_dataCollected_schedule_label: 'Schedule Data',
  legal_privacy_dataCollected_title: 'Data Collected',
  legal_privacy_dataCollected_wages:
    "Hourly rates, salary amounts, break durations, and calculated hours. Stored in your device's local database. Synced only to your own Google Drive or OneDrive if you enable cloud sync.",
  legal_privacy_dataCollected_wages_label: 'Wages & Hours',
  legal_privacy_localStorage_p1:
    'All primary data is stored locally on your device in an embedded database. This data is not accessible to other websites or apps. If you clear your browser or app data, your PunchLog data is permanently and irreversibly deleted. We recommend exporting your data regularly from Settings > Data & Privacy.',
  legal_privacy_localStorage_title: 'Local Storage',
  legal_privacy_noTracking_p1:
    'PunchLog contains no advertising SDKs, no analytics trackers, and no third-party telemetry. We do not sell your data. We do not use cookies for tracking.',
  legal_privacy_noTracking_title: 'No Tracking, No Ads',
  legal_privacy_overview_p1:
    'PunchLog is designed to minimize the data we collect. Your time entries, wages, GPS locations, and personal notes never leave your device unless you explicitly enable cloud sync. This policy describes what data we collect and how we use it.',
  legal_privacy_overview_title: 'Overview',
  legal_privacy_servers_p1:
    'For paid subscribers, Cloudflare D1 stores subscription status, tier, seat count, and hosted invoice records. Cloudflare R2 stores hosted invoice PDFs. This data is limited to what is necessary to provide your subscription features. We do not store your time entries, wages, or personal notes on any server.',
  legal_privacy_servers_title: 'Server-Side Data (Paid Tiers Only)',
  legal_privacy_signing_p1:
    "PunchLog's audit trail uses SHA-256 hashing. When you seal your time entries, only a 64-character hexadecimal hash of your data leaves your device. No wages, locations, employer names, or shift notes are ever sent to the signing server. The signing server cannot reverse the hash to recover your data.",
  legal_privacy_signing_title: 'Zero-Knowledge Cryptographic Signing',
  legal_privacy_stripe_p1:
    "Paid subscriptions are processed by Stripe. PunchLog does not store your credit card number. Stripe's privacy policy governs payment data: https://stripe.com/privacy.",
  legal_privacy_stripe_title: 'Payment Processing',
  legal_privacy_thirdParty_cloudflare:
    'Cloudflare: serverless backend and storage (cloudflare.com/privacypolicy)',
  legal_privacy_thirdParty_gdrive:
    'Google Drive: optional user-owned cloud sync (policies.google.com/privacy)',
  legal_privacy_thirdParty_onedrive:
    'OneDrive: optional user-owned cloud sync (microsoft.com/privacy)',
  legal_privacy_thirdParty_p1:
    'PunchLog integrates with the following third-party services, each subject to their own privacy policies:',
  legal_privacy_thirdParty_stripe: 'Stripe: payment processing (stripe.com/privacy)',
  legal_privacy_thirdParty_title: 'Third-Party Services',
  legal_privacy_title: 'Privacy Policy',
  legal_tos_acceptableUse_b1: 'Use PunchLog for any unlawful purpose.',
  legal_tos_acceptableUse_b2:
    'Attempt to reverse-engineer, decompile, or extract proprietary algorithms from the app.',
  legal_tos_acceptableUse_b3:
    'Use automated tools to interact with the app in a way that circumvents rate limits or billing.',
  legal_tos_acceptableUse_p1: 'You agree not to:',
  legal_tos_acceptableUse_title: 'Acceptable Use',
  legal_tos_changes_p1:
    'We may update these terms from time to time. Material changes will be announced in-app. The "Last updated" date at the top of this page reflects the most recent revision. Your continued use of PunchLog after changes take effect constitutes acceptance of the revised terms.',
  legal_tos_changes_title: 'Changes to These Terms',
  legal_tos_contact_title: 'Contact',
  legal_tos_data_p1:
    'You own your time entry data. PunchLog stores data locally on your device. Paid-tier metadata (subscription status, seat count, hosted invoices) is stored in Cloudflare D1 to provide your subscription features. You may export all your data at any time from Settings > Data & Privacy.',
  legal_tos_data_title: 'Your Data',
  legal_tos_freeTier_p1:
    'The free tier provides local-only time tracking with no account required. Your data stays on your device and is not backed up to any server. Free tier users may create up to 5 hosted invoice links per month.',
  legal_tos_freeTier_title: 'Free Tier',
  legal_tos_liability_p1:
    'PunchLog is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of the app, including but not limited to loss of data, inaccurate time calculations, or missed legal deadlines.',
  legal_tos_liability_title: 'Limitation of Liability',
  legal_tos_notLegalAdvice_p1:
    'PunchLog is a time tracking and invoicing tool. Nothing in this app, including exported reports, timesheets, audit bundles, or any other generated content, constitutes legal advice. PunchLog does not have an attorney-client relationship with any user.',
  legal_tos_notLegalAdvice_p2:
    'You should consult a qualified attorney for legal guidance regarding wage disputes, labor law compliance, wage complaints, or any other legal matter. Exported documents are records of your own data, not legal filings.',
  legal_tos_notLegalAdvice_title: 'Not Legal Advice',
  legal_tos_subscription_b1:
    'Subscriptions renew monthly unless you cancel before your next billing date.',
  legal_tos_subscription_b2:
    'You may cancel at any time through the Stripe Customer Portal, accessible from the Plan & Features settings screen. You will not be charged again after cancellation.',
  legal_tos_subscription_b3:
    'Upon cancellation, your subscription remains active until the end of the current billing period.',
  legal_tos_subscription_b4:
    "Refund requests are handled on a case-by-case basis. Contact support{'@'}ddproxy.com.",
  legal_tos_subscription_p1:
    'Paid subscriptions are processed through Stripe. By subscribing, you agree to the following terms:',
  legal_tos_subscription_title: 'Subscription and Billing',
  legal_tos_title: 'Terms of Service',
  // ── Legal pages ──────────────────────────────────────────────────────────
  legal_updated: 'Last updated',

  // ── Billing / Invoice history ────────────────────────────────────────────
  billing_historyHeader: 'Recent Payments',
  billing_loading: 'Loading payment history…',
  billing_noInvoices: 'No payment history yet.',
  billing_status_draft: 'Draft',
  billing_status_open: 'Open',
  billing_status_paid: 'Paid',
  billing_status_past_due: 'Past due',
  billing_status_uncollectible: 'Uncollectible',
  billing_status_unknown: 'Unknown',
  billing_status_void: 'Void',
  billing_viewReceipt: 'Receipt',

  help_contactBody:
    'Have a question or need help? Send us an email and we will respond as soon as possible.',
  help_contactHeader: 'Contact Us',
  help_faq_auditTrailBody:
    'When you seal your time entries, PunchLog generates a SHA-256 hash of your data. Only the hash leaves your device. No wages, locations, or notes are ever sent to the server. The seal proves your records have not been altered since sealing.',
  help_faq_auditTrailTitle: 'How does the cryptographic audit trail work?',
  help_faq_cancelBody:
    'Go to Settings, then Plan & Features. Tap Manage Subscription to open the Stripe customer portal where you can cancel or change your plan. Your subscription remains active until the end of the current billing period. Your time data stays on your device after cancellation.',
  help_faq_cancelTitle: 'How do I cancel my subscription?',
  help_faq_cloudSyncBody:
    'Go to Settings, then Sync & Cloud. Tap Connect to link your Google Drive or Microsoft OneDrive account. Once connected, PunchLog backs up your data to your cloud storage. You can also save exports directly to your connected drive.',
  help_faq_cloudSyncTitle: 'How do I connect Google Drive or OneDrive?',
  help_faq_exportBody:
    'Open the Planner tab, select your date range, then tap Export. Choose "Timesheet Report" to generate a PDF with all your hours, entries, and an optional cryptographic seal for tamper-evidence.',
  help_faq_exportTitle: 'How do I export a wage record audit bundle?',
  help_faq_invoiceLimitBody:
    'Each plan includes a monthly limit on hosted invoice links. The free tier includes 5 per month. Check your current usage in Settings under Plan & Features, or upgrade for a higher limit.',
  help_faq_invoiceLimitTitle: "Why can't I create a hosted invoice link?",
  help_faqHeader: 'Frequently Asked Questions',
  // ── Help & Support ─────────────────────────────────────────────────────
  help_title: 'Help & Support',

  notif_bellAria: 'Notifications',
  notif_dismiss: 'Dismiss',
  notif_empty: 'No notifications',
  notif_invoiceLimitBody:
    'You have reached the monthly hosted invoice link limit. Upgrade your plan for a higher limit, or Business for unlimited links.',
  notif_invoiceLimitTitle: 'Invoice limit reached',
  notif_markAllRead: 'Mark all read',
  notif_pastDueBody:
    'Your subscription payment could not be processed. Update your payment method to keep your plan active.',
  notif_pastDueTitle: 'Payment failed',
  // ── Notifications ─────────────────────────────────────────────────────────
  notif_title: 'Notifications',

  account_codeLabel: 'Verification code',
  account_codePlaceholder: '6-digit code',
  account_codeSent: 'Code sent. Check your inbox.',
  account_digestLabel: 'Monthly summary email',
  account_digestOff: 'Off',
  account_digestOn: 'On',
  account_emailLabel: 'Email address',
  account_emailPlaceholder: "you{'@'}example.com",
  account_errorSending: 'Could not send code.',
  account_errorVerifying: 'Could not verify code.',
  account_sendCode: 'Send code',
  account_sending: 'Sending...',
  account_signedIn: 'Signed in successfully.',
  account_signedInAs: 'Signed in as',
  account_signedOut: 'Signed out.',
  account_signOut: 'Sign out',
  account_signOutConfirmBody: 'You will need to enter your email and a new code to sign in again.',
  account_signOutConfirmTitle: 'Sign out?',
  // ── Account ─────────────────────────────────────────────────────────────
  account_title: 'Account',
  account_unauthHint:
    'Sign in to sync your data across devices, get hosted invoices, and manage your subscription.',
  account_verify: 'Verify',
  account_verifying: 'Verifying...',

  // ── Tier badge ─────────────────────────────────────────────────────────
  tierBadge_requires: 'Requires {tier}',

  invoice_amountDue: 'Amount Due',
  invoice_billTo: 'Bill To',
  invoice_colAmount: 'Amount',
  invoice_colDescription: 'Description',
  invoice_colHours: 'Hours',
  invoice_colRate: 'Rate',
  invoice_from: 'From',
  invoice_issued: 'Issued',
  // ── Public invoice view ──────────────────────────────────────────────────
  invoice_loading: 'Loading invoice…',
  invoice_notFound: 'This invoice could not be found. The link may be incorrect or expired.',
  invoice_status_sent: 'Sent',
  invoice_status_viewed: 'Viewed',
  invoice_subtotal: 'Subtotal',
  invoice_tax: 'Tax',
  invoice_title: 'Invoice',
};
